export const setFirstGuestPurchase = () =>
  localStorage.setItem('first-guest-purchase', true)

export const getFirstGuestPurchase = () =>
  localStorage?.getItem('first-guest-purchase')

export const removeFirstGuestPurchase = () =>
  localStorage.removeItem('first-guest-purchase')
